const popup = document.getElementById('popup'); 
const allowButton = document.getElementById('allowButton'); 
const denyButton = document.getElementById('denyButton'); 

window.onload = function() { 
  if(sessionStorage.allow) return;
  popup.style.display = 'block'; 
} 

denyButton.onclick = function() {
  denyButton.disabled = false;
  window.location.href = 'https://www.google.com/';
  if (!localStorage.getItem('popupShown')) {
    denyButton.disabled = true;
    window.location.href = 'https://www.google.com/';
  }
};

allowButton.onclick = function() { 
    popup.style.display = 'none'; 
    sessionStorage.allow = true;
}